/**
 * 鼠标动作动画
 */
import fvAnimation from "./fvAnimation"
export default class fvMousescript extends fvAnimation {
    constructor(shape){
        super(shape,"fvMousescript");
        this.inFlag = 0;
        this.enterFunction = null;
        this.exitFunction = null;
        this.overFunction = null;
        this.moveFunction =  null;
        try {
            this.enterFunction = AsyncFunction(this.enterscript);//移入
            this.exitFunction = AsyncFunction(this.exitscript);//移出
            this.overFunction = AsyncFunction(this.overscript);//悬停
            this.moveFunction =  AsyncFunction(this.movescript);//移动
        } catch (error) {
            console.error(error);
            return;
        }
        
        this.overTimerFunction = function(){
            if(this.inFlag == 0) return;
            this.overFunction();
            setTimeout(this.overTimerFunction,this.overTimer);
        }.bind(this);
    }

    run(event,show){
        if(show == "进入"){
            this.inFlag = 1;
            this.executionScript(this.enterFunction);
            this.executionScript(this.overTimerFunction);
        }else if(show == "离开"){
            this.inFlag = 0;
            this.executionScript(this.exitFunction);
        }else if(show == "移动"){
            this.executionScript(this.moveFunction);
        }
    }
}





// WEBPACK FOOTER //
// ./src/js/div/animationDiv/fvMousescript.js